module.exports = __webpack_public_path__ + "img/0Q3A5108-23_P_L_Wood.d2f6c4fc.jpg";